import * as i18next from 'i18next';

export const init = (lng, resources, onReady) => {
  return i18next.init({
    lng,
    keySeparator: '$',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    resources
  }, (err, t) => {
    onReady && onReady(t);
  });
};
export default i18next;



// WEBPACK FOOTER //
// ./utils/i18n.ts